import React from 'react';
import wrapStore from '@src/utils/wrap-store';
import Page from '@src/components/page';
import BackTopFooter from '@src/business-components/backtop-footer';
import LoadingDiv from '@src/components/loading-div';
import getLanguageByPath from '@src/utils/locale/getLanguageByPath';
import EmptyDataTip from '@src/business-components/empty-data-tip';
import Photo from './components/photo';
import Store from './store';
const styles = require('./index.less');
const lang = getLanguageByPath();

const Wallpaper = ({ store }) => {
  store.use();

  return (
    <Page _ref={store.containerRef} getScrollingContainer={() => store.containerRef.current} className={styles.root}>
      <h2 data-hide-txt className={styles.title} style={{ backgroundImage: `url(${require('./images/' + lang + '/title.png')})` }}>
        wallpapers
      </h2>
      {!store.originPhotos.length ? <EmptyDataTip /> : null}
      {store.loading && <LoadingDiv />}
      <section id="wallMain" className={styles.content}>
        {store.photos.map((item, index) => <Photo key={index} index={index} thumb={item.thumb} src={item.src} />)}
      </section>
      {/* 底部版权栏 */}
      {<BackTopFooter btns={['copyright']} position="fixed" onBackTop={store.backTop} />}
    </Page>
  );
};

export default wrapStore(Wallpaper, Store);
